import { render, staticRenderFns } from "./ProductStockList.vue?vue&type=template&id=2348c74c&scoped=true&"
import script from "./ProductStockList.vue?vue&type=script&lang=js&"
export * from "./ProductStockList.vue?vue&type=script&lang=js&"
import style0 from "./ProductStockList.vue?vue&type=style&index=0&id=2348c74c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2348c74c",
  null
  
)

export default component.exports